 import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AOS from 'aos';
 import 'aos/dist/aos.css';
 import Navigation from "./components/navigation/Navigation";
 import ScrollToTop from "./components/navigation/ScrollToTop";

 AOS.init();
export default function App() {
    return (<>
        <ScrollToTop/>
        <ToastContainer pauseOnFocusLoss={false} pauseOnHover={false} newestOnTop={true} closeButton={true}
                         closeOnClick={true}/>
         <Navigation/>
     </>)
 }


// import { useEffect } from 'react';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import Navigation from "./components/navigation/Navigation";
// import ScrollToTop from "./components/navigation/ScrollToTop";

// AOS.init();

// export default function App() {
//     useEffect(() => {
//         // Tawk.to script injection
//         var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
//         (function() {
//             var s1 = document.createElement("script");
//             var s0 = document.getElementsByTagName("script")[0];
//             s1.async = true;
//             s1.src = 'https://embed.tawk.to/66ffb80637379df10df1ae36/1i9bedn3j';
//             s1.charset = 'UTF-8';
//             s1.setAttribute('crossorigin', '*');
//             s0.parentNode.insertBefore(s1, s0);
//         })();
//     }, []); // Runs only once when the component mounts.

//     return (
//         <>
//             <ScrollToTop />
//             <ToastContainer
//                 pauseOnFocusLoss={false}
//                 pauseOnHover={false}
//                 newestOnTop={true}
//                 closeButton={true}
//                 closeOnClick={true}
//             />
//             <Navigation />
//         </>
//     );
// }

